<template>
    <div class="person-item-wrapper">
        <!-- :title="$t(`${baseTranslateID}.msg.click_more_info`)" -->
        <div
            class="person-item"
            data-toggle="tooltip-city"
            data-placement="right"
            @click.prevent="openPersonDetail">
            <p class="full-name">{{ personName }}</p>
            <p class="role"> {{ $t(`${translateID}.form.type.${personType}`) }} </p>
        </div>
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";

export default {
    mixins: [
        CemeteryElementMixin
    ],
    props: {
        baseTranslateID: {
            type: String,
            default: 'entities',
        },
        personType: {
            type: String,
            default: 'holder',
        },
    },
    data() {
        return {
        }
    },
    mounted() {
        // this.$nextTick(function () {
        //     this.$root.$helper.global.activeTooltip();
        // });
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID}`
        },
        modelTranslateID() {
            return `${this.translateID}.model`
        },
        person() {
            return this.value ?? {};
        },
        personName() {
            return this.person?.name;
        },
        personTags() {
            return null;
        },
        personDetailHtml() {
            let txt = `<div class="notes-block person-details-wrapper">
                <div class="info-card-container">
                    <div class="detail-container">
                        <h3 class="name">${this.personName}</h3>
                        <div class="div-table">
                            ${this.personDetailItems}
                        </div>
                    </div>
                </div>
            </div>`;

            return txt;
        },
        personDetailItems() {
            let items = [];

            [
                'full_address',
                'phone',
                'email',
            ].forEach(key => {
                let info = this.itemInfo(key);
                if(info) {
                    items.push(
                        `<div class="div-table-row">
                            <div class="div-table-col-key">${this.$t(`${this.modelTranslateID}.${key}`)}:</div>
                            <div class="div-table-col-value">${info}</div>
                        </div>`
                    );
                }
            });
            return items.join('');
        }
    },
    methods: {
        itemInfo(key) {
            return this.person[key];
        },
        openPersonDetail() {
            this.$root.$emit('openInfo', {
                title: this.$t(`entities.title`),
                html: this.personDetailHtml,
                callback: (id, name) => {},
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.person-item-wrapper{
    p {
        margin-bottom: 12px;
    }

    .person-item {
        background: #f5f5f5;
        border-radius: 4px;
        cursor: pointer;
        padding: 8px 8px 2px 16px;

        .full-name {
            font-family: var(--city-medium-font-family);
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            margin-bottom: 5px;
            color: #181429;
        }

        .role {
            letter-spacing: .5px;
            font-weight: 700;
            font-size: 10px;
            line-height: 12px;
            text-transform: uppercase;
            color: var(--primary-color);
        }
    }
}
</style>